import React, { useState } from 'react';

import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import TextField from './TextField';

const PasswordField = React.forwardRef((props, ref) => {
  const { InputProps, ...restProps } = props;

  const [visible, setVisible] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setVisible((current) => !current);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <TextField
      autoComplete="current-password"
      {...restProps}
      ref={ref}
      type={visible ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              edge="end"
              size="small"
              aria-label="toggle password visibility"
              onMouseDown={handleMouseDownPassword}
              onClick={handleTogglePasswordVisibility}
            >
              {visible
                ? (
                  <VisibilityOutlined
                    fontSize="small"
                    color="disabled"
                  />
                )
                : (
                  <VisibilityOffOutlinedIcon
                    fontSize="small"
                    color="disabled"
                  />
                )}
            </IconButton>
          </InputAdornment>
        ),
        ...InputProps,
      }}
    />
  );
});

PasswordField.displayName = 'PasswordField';
export default PasswordField;
